import { SessionViewInfoCard } from "./SessionViewInfoCard";

export default SessionViewInfoCard;
